module.exports = __webpack_public_path__ + "47b2bcfd54e9ed1e6bdb09f3bfbff9a9.pdf";